import PropTypes from 'prop-types'
import React from 'react'

import {
  queryWithoutFilters,
  activeFiltersParams
} from '../../../../../common/utils/urlHelper'
import SearchLink from '../../../../shared/containers/searchLinkContainer'
import CactusIcon from '../../../../shared/components/icons/cactus'

import styles from './searchNoResults.module.css'

const SearchNoResults = ({ locationParams }) => {
  const renderClearFiltersLink = () => {
    const link = (
      <SearchLink
        locationParams={queryWithoutFilters(locationParams)}
        className="fds-c-text-link -decoration-reversed"
      >
        clearing your filters
      </SearchLink>
    )

    return <span>Try {link}.</span>
  }

  return (
    <div className={styles.searchNoResult}>
      <div className="search-no-results">
        <div>
          <CactusIcon width="100" height="150" />
        </div>
        <div>
          <h2 className="fds-c-text-heading -size-xs">
            You&apos;ve ventured too far out into the desert!{' '}
            {activeFiltersParams(locationParams).length
              ? renderClearFiltersLink()
              : 'Time to head back'}
          </h2>
          <p className="fds-c-text-body">
            {activeFiltersParams(locationParams).length
              ? "We couldn't find any results for your search within the filters you've set."
              : "We couldn't find any results for your search. Use more generic words or double check your spelling."}
          </p>
        </div>
      </div>
    </div>
  )
}

SearchNoResults.propTypes = {
  locationParams: PropTypes.object
}

export default SearchNoResults
